
import Vue from 'vue';
/**
 * 将对象中的属性封装为URLSearchParams对象
 * @param parameters
 * @returns {URLSearchParams}
 */
Vue.prototype.buildParams = function(parameters) {
  var urlSearchParams = new URLSearchParams();
  for (var key in parameters) {
    if (undefined === parameters[key] || parameters[key] === null) {
      continue;
    }
    if (typeof parameters[key] === 'string') {
      urlSearchParams.append(key, parameters[key].trim());
    } else {
      urlSearchParams.append(key, parameters[key]);
    }
  }
  return urlSearchParams;
};

